import { DOCUMENT } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Environment, ENVIRONMENT } from '@shared/environment';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Component({
	selector: 'app-block-app-dialog',
	templateUrl: './block-app-dialog.component.html',
	styleUrls: ['./block-app-dialog.component.css'],
	standalone: true,
	imports: [MatDialogModule, MatButtonModule],
})
export class BlockAppDialogComponent implements OnInit {
	private readonly document = inject(DOCUMENT);
	private readonly environment = inject<Environment>(ENVIRONMENT);
	constructor(
		public dialogRef: MatDialogRef<BlockAppDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {}

	async onAllowClick(): Promise<void> {
		const platform = Capacitor.getPlatform();
		const url = platform === 'android' ? this.environment.androidLink : this.environment.iosLink;

		if (Capacitor.isNativePlatform()) {
			await Browser.open({ url });
		} else {
			this.document.defaultView!.open(url, '_self');
		}
	}
}
